module.exports = __webpack_public_path__ + "img/avatar.591768ae.svg";